<template>
  <div>
    <div class="file-upload" :style="{marginBottom: !disabled && fileList.length == 0 ? '2px' : '-22px'}">
      <ul class="el-upload-list el-upload-list--picture-card is-disabled">
        <li v-for="(file, index) in fileList" :key="file.url" :tabindex="index" class="el-upload-list__item is-success" style="border: 0px;">
          <video v-if="isVideo(file)" :src="file.url" style="width: 100%;height: 100%"></video>
          <img v-else :src="getUrl(file)" style="width: 100%;height: 100%" />
          <span v-if="isVideo(file)" class="el-upload-list__item-actions" style="opacity: 1;">
            <span class="el-upload-list__item-preview" @click="handlePlay(file)" style="display: inline-block;">
              <i class="el-icon-video-play"></i>
            </span>
          </span>
          <span v-else class="el-upload-list__item-actions">
            <span v-if="isImage(file)" class="el-upload-list__item-preview" @click="handlePreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-else class="el-upload-list__item-delete" @click="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span>
            <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file, index)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </li>
        <li v-if="fileUploading" class="el-upload-list__item is-uploading">
          <el-progress
            type="line"
            :stroke-width="4"
            :percentage="parsePercentage(percentage)">
          </el-progress>
        </li>
        <li v-if="disabled && fileList.length == 0" class="el-upload-list__item is-success" style="border: 1px solid #c0ccda; text-align: center; color: #c0ccda;">
          无数据
        </li>
      </ul>
      <ImageViewer
        v-if="showViewer"
        :z-index="20000"
        :initial-index="initialIndex"
        :on-close="() => showViewer = false"
        :url-list="imageList">
      </ImageViewer>
      <el-dialog
        v-if="dialogVisible"
        title="视频播放"
        :visible.sync="dialogVisible"
        @close='dialogVisible = false'
        append-to-body
        width="800px">
        <video autoplay :src="dialogVideoUrl" controls="controls" style="width: 100%;height: 450px;"></video>
      </el-dialog>
      <el-upload
        v-if="!disabled"
        :action="action"
        :size="size"
        list-type="picture-card"
        :style="{display: fileList.length < limit ? 'inline' : 'none'}"
        :show-file-list="false"
        :auto-upload="true"
        :limit="limit"
        :headers="headers"
        :file-list="fileList"
        :before-upload="beforeUpload"
        :on-change="handleChange"
        :on-success="handleSuccess"
        :on-error="handleError"
        :on-progress="handleProgress"
        :on-preview="handlePreview"
        :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
import ElProgress from 'element-ui/packages/progress';
import { FILE_UPLOAD_URL, downFileApi, getFileListByIds } from "@/util/api";

const headers = {
  'Authorization': window.localStorage.getItem('token')
};

export default {
  components: {
    ImageViewer,
    ElProgress
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  mixins: [emitter],
  props: {
    value: Array,
    suffix: String,
    defaultSuffix: {
      type: String,
      default: 'file'
    },
    limit: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      action: FILE_UPLOAD_URL,
      headers: headers,
      val: this.value,
      isOverflow: false,
      percentage: 0,
      fileUploading: false,
      fileList: [],
      imageList: [],
      initialIndex: 0,
      showViewer: false,
      dialogVisible: false,
      dialogVideoUrl: null
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function(value) {
        this.val = value;
        this.initFileList();
      }
    },
    limit: {
      handler (val) {
        this.limit = val;
      }
    }
  },
  methods: {
    initFileList () {
      if (this.val && this.val.length > 0 && this.fileList.length == 0) {
        getFileListByIds(this.val).then(res => {
          if (res.responseData && res.responseData.length > 0) {
            res.responseData.map(file => {
              this.fileList.push({
                id: file.id,
                url: file.fileUrl,
                name: this.getFileName(file.fileName)
              })
            });
          }
        });
      }
    },
    beforeUpload (file) {},
    handleProgress (event) {
      this.fileUploading = event.percent != 100;
      this.percentage = event.percent;
    },
    handleSuccess (response, file, fileList) {
      if (response.msgCode == 200) {
        let res = response.responseData;
        this.fileList.push({
          id: res.id,
          url: file.url,
          name: this.getFileName(res.fileName)
        });
        this.val = this.val || [];
        this.val.push(res.id);
        this.handleChange()
      } else {
        this.$message.error(response.msg);
      }
    },
    handleError (err, file, fileList) {
      console.log(err, file, fileList)
    },
    getUrl (file) {
      let suffix = this.getSuffix(file);
      if (this.isImage(file)) {
        return file.url;
      } else if (['rar', 'zip'].indexOf(suffix) > -1) {
        return '/static/zip.png';
      } else if (['doc', 'docx', 'wps'].indexOf(suffix) > -1) {
        return '/static/icon/word-ext.png';
      } else if (['ppt', 'pptx'].indexOf(suffix) > -1) {
        return '/static/icon/ppt-ext.png';
      } else if (['xls', 'xlsx'].indexOf(suffix) > -1) {
        return '/static/icon/excel-ext.png';
      } else if (['pdf'].indexOf(suffix) > -1) {
        return '/static/icon/pdf-ext.png';
      } else if (['mp4'].indexOf(suffix) > -1) {
        return '/static/icon/mp4-ext.png';
      } else {
        return '/static/file.png';
      }
    },
    isImage (file) {
      let suffix = this.getSuffix(file);
      return ['jpg', 'jpeg', 'png', 'bmp', 'image'].indexOf(suffix.toLowerCase()) > -1;
    },
    isVideo (file) {
      let suffix = this.getSuffix(file);
      return ['mp4'].indexOf(suffix.toLowerCase()) > -1;
    },
    getSuffix(file) {
      if (this.suffix) return this.suffix;
      return file.name && file.name.indexOf('.') > -1 ? file.name.substring(file.name.lastIndexOf('.') + 1) : this.defaultSuffix;
    },
    handleChange (file, fileList) {
      this.dispatch('ElFormItem', 'el.form.change', this.val);
      this.dispatch('ElFormItem', 'el.form.blur', this.val);
      this.$emit('change', this.val);
    },
    handlePreview (file) {
      this.imageList = this.fileList.filter(f => {
        return this.isImage(f);
      }).map((f, i) => {
        if (f.id == file.id) {
          this.initialIndex = i;
        }
        return f.url;
      });
      this.showViewer = true;
    },
    handlePlay (file) {
      this.dialogVisible = true;
      this.dialogVideoUrl = file.url;
    },
    handleDownload (file) {
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = file.url;
      link.setAttribute('target', '_blank');
      link.setAttribute('download', file.name);
      document.body.appendChild(link);
      link.click();
    },
    handleRemove (file, index) {
      this.fileList.splice(index, 1);
      this.val.splice(index, 1);
      this.handleChange();
    },
    parsePercentage(val) {
      return parseInt(val, 10);
    },
    getFileName (fileName) {
      if (fileName && fileName.lastIndexOf('-') > 0 && fileName.lastIndexOf('.') > fileName.lastIndexOf('-')) {
        return fileName.replace(fileName.substring(fileName.lastIndexOf('-'), fileName.lastIndexOf('.')), '');
      }
      return fileName;
    }
  }
}
</script>

<style scoped  lang="scss">
/deep/ .file-upload {
  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  .el-upload-list__item {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  .el-upload-list__item {
    .is-uploading {
      width: 80px;
    }
  }
}
/deep/ .el-dialog__header{
  padding-left: 16px;
  padding-bottom: 16px;
  .el-dialog__headerbtn .el-dialog__close{
    color: #909399;
    font-size: 30px;
    cursor: pointer;
  }
  .el-dialog__headerbtn .el-dialog__close:hover{
    color: #E8556F;
  }
  .el-dialog__title{
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business/FileUpload.vue